<div class="row g-4">
    @if (access.missing216) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="216 Missing Score">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadMissing216"
                    centerText="My Score"
                    [useCapitalCaseFormatting]="false"
                    [scoreCountsAsData]="true"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.putaway260) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="260 Putaway Score">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadPutaway260"
                    centerText="My Score"
                    [useCapitalCaseFormatting]="false"
                    [scoreCountsAsData]="true"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.blockedStock) {
        <div class="col-12">
            <app-blocked-stock-chart
                title="Blocked Stock"
                [data]="blockedStock"
                [series]="blockedStockSeries"
                [formatPercent]="false"
                [aggregateType]="AggregateType.Day"
                [wholeRange]="blockedStockRange"
                [visualRange]="blockedStockRange"
            ></app-blocked-stock-chart>
        </div>

        <div class="col-12 col-lg-6">
            <app-blocked-stock-doughnut-chart
                title="Days On Hold"
                [data]="blockedStock"
                [segments]="daysOnHoldSegments"
                centerMode="largest"
            ></app-blocked-stock-doughnut-chart>
        </div>

        <div class="col-12 col-lg-6">
            <app-blocked-stock-doughnut-chart
                title="Reason"
                [data]="blockedStock"
                [segments]="reasonSegments"
                centerMode="total"
                totalField="totalBlockedStock"
                centerLabel="Blocked"
            ></app-blocked-stock-doughnut-chart>
        </div>
    }
</div>
